<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  width: 100%;
  min-height: 100%;
}
.h5{
    width: 100%;
    height: 5px;
  }
.h10{
    width: 100%;
    height: 10px;
  }
  .h20{
    width: 100%;
    height: 20px;
  }
  /***
  .mouse-cover-canvas{
    position: absolute;
    left: 949px !important;
    top:529px !important;
    display: none;
   }
   */
body {
       margin: 0px;
       font-family: "微软雅黑";
     }

html,body {
  width: 100%;
  height: 100%;
  }
a{
	text-decoration: none;
}
ul{
	list-style: none;
}
#aboutHtml img,#aboutHtml_notice img,#aboutHtml_2 img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue